import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star_alt",
  "use": "star_alt-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"star_alt\"><path fill=\"none\" stroke=\"#949494\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2.1\" d=\"M11.163 6.279l4.837.69-3.5 3.329.826 4.702L9 12.779 4.674 15l.826-4.702L2 6.969l4.837-.69L9 2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol